"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMobile = exports.getBreakpoint = exports.breakpoints = void 0;
const breakpoints = exports.breakpoints = {
  mobile: 519,
  phablet: 767,
  tablet: 991,
  desktop: 1199,
  large: 1719,
  xlarge: Infinity
};
const getBreakpoint = () => {
  if (window && window.innerWidth) {
    const width = window.innerWidth;
    if (width <= breakpoints.mobile) {
      return 'mobile';
    }
    if (width <= breakpoints.phablet) {
      return 'phablet';
    }
    if (width <= breakpoints.tablet) {
      return 'tablet';
    }
    if (width <= breakpoints.desktop) {
      return 'desktop';
    }
    if (width <= breakpoints.large) {
      return 'large';
    }
    return 'xlarge';
  }
  return null;
};
exports.getBreakpoint = getBreakpoint;
const isMobile = () => {
  const breakpoint = getBreakpoint();
  return breakpoint === breakpoints.mobile || breakpoint === breakpoints.phablet;
};
exports.isMobile = isMobile;